export default __webpack_public_path__ + "static/media/Logout-documentation.c57c0063.md";